import { FixDepositRegister } from "../models/fixdepositregister.model";
import { Group } from "../models/group.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getFixDepositRegister = (group: Group | undefined): Promise<FixDepositRegister[]> => {
    return new Promise<FixDepositRegister[]>((resolve, reject) => {
        if(!group) return; // :D

        responseHero.get(`${process.env.REACT_APP_API_URL}/fdr/group/${group?.group_id}`).then((response) => {
            resolve(response.data as FixDepositRegister[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};